import { labeled, boolean, stringRequired, custom } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  custom(Joi)
    .object()
    .keys({
      taxPurposes: boolean(Joi).label(
        labeled(label, 'For tax purposes (no tax advice is being given)')
      ),
      discountsOnInterestRate: boolean(Joi).label(labeled(label, 'Discounts on interest rate')),
      assistWithCashFlow: boolean(Joi).label(
        labeled(label, 'To assist with cash flow and budgeting')
      ),
      other: boolean(Joi).label(labeled(label, 'Other'))
    })
    .orValue('taxPurposes', 'discountsOnInterestRate', 'assistWithCashFlow', 'other')
    .label(label)
    .when('.other', {
      is: true,
      then: Joi.object({
        otherComments: stringRequired(Joi, 1, 4096).label(labeled(label, 'Details'))
      })
    });

export default {
  schema
};
